import { connect } from "react-redux";
import ConfigHelpdesk from "./configHelpdesk";
import { bindActionCreators } from "redux";
import { userdropdown, approverdropdown, saveuserConfig, updateUserConfig, getUserData } from "../../../services/redux/userHelpdesk/action";

const mapStateToProps = (state) => ({
    userdropdownlist : state.UserHelpdesk.userdropdown,
    approverdropdownlist : state.UserHelpdesk.approverdropdown,
    updateuserconfiglist : state.UserHelpdesk.updateuserconfig,
    getautofilldatalist : state.UserHelpdesk.getautofilldata
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        userdropdown,
        approverdropdown,
        saveuserConfig,
        updateUserConfig,
        getUserData,
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ConfigHelpdesk);